const MapClusterMarker = ({
  numOfClusters,
  clusterPointCount,
  totalPointCount,
  handleClick,
  currentZoom,
  totalVisiblePointCount,
}: {
  numOfClusters: number;
  clusterPointCount: number;
  totalPointCount: number;
  totalVisiblePointCount: number;
  handleClick: () => void;
  lat: number;
  lng: number;
  currentZoom: number;
}) => {
  // console.log("currentZoom: ", currentZoom);
  // console.log("numOfClusters: ", numOfClusters);
  // console.log("clusterPointCount: ", clusterPointCount);
  // console.log("totalPointCount: ", totalPointCount);
  // console.log("totalVisiblePointCount: ", totalVisiblePointCount);
  // calculate the size of the div relative to the point count
  let size;
  if (currentZoom >= 6) {
    size = 20 + (clusterPointCount / totalVisiblePointCount) * 100 * 2;
  } else if (currentZoom <= 4) {
    size = 20 + (clusterPointCount / totalVisiblePointCount) * 100 * 0.2;
  } else {
    size = 20 + (clusterPointCount / totalVisiblePointCount) * 100 * 1.5;
  }

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        marginTop: `-${size / 2}px`,
        marginLeft: `-${size / 2}px`,
        borderRadius: `${size / 2}px`,
      }}
      onClick={handleClick}
      className="clusterMarker"
    >
      <p>{clusterPointCount}</p>
    </div>
  );
};

export default MapClusterMarker;
